module.exports = __webpack_public_path__ + "img/testimonials3.9018240f.jpg";